export var ChainType;
(function (ChainType) {
    ChainType["EVM"] = "EVM";
    // Solana virtual machine
    ChainType["SVM"] = "SVM";
})(ChainType || (ChainType = {}));
